<template>
  <div
    class="item-layout"
    :class="{ active: item.active }"
    @click="$emit('on-menu-click', item)"
  >
    <b-icon :icon="item.icon"></b-icon>
    <h4 class="body-text" :class="{ whiteText: item.active }">
      {{ item.text }}
    </h4>
    <h4 v-if="item.alert" class="body-text text-color-red pl-2 pr-2 pt-1 pb-1">
      {{ item.alert }}
    </h4>
  </div>
</template>

<script lang="ts">
import { ItemMenu } from '@/store/navigation/types'
import Vue, { PropType } from 'vue'

export default Vue.extend({
  name: 'MenuItem',

  props: {
    item: {
      type: Object as PropType<ItemMenu>,
      required: true
    }
  }
})
</script>

<style lang="sass" scoped>
@import @/assets/sass/style

.item-layout
    display: flex
    justify-content: flex-start
    height: 55px
    align-items: center
    border-radius: 8px
    gap: 0px 10px
    padding-left: 24px

    &:hover
        background: $link
        cursor: pointer

.active
    background: $primary
    color: $white

    &:hover
        background: $info
.whiteText
    color: $white

.span-alert
  background-color: $secondary
</style>
